import { ConfirmationDialogRaw } from "@/controls/modals/ConfirmationDialogRaw";
import { FooterModalButtons } from "@/controls/buttons/FooterModalButtons";
import { modalStyles } from "@/shared/styles/modalStyles";
import { MesfModal } from "@dexteel/mesf-core";
import { Grid, ToggleButton } from "@mui/material";
import { useState, useEffect } from "react";
import { LADLE_CAR_COLORS } from "../../constants/ladleCarColors";

interface Props {
  open: boolean;
  onHide: () => void;
  currentLadleCar: number | null;
  onSave: (ladleCar: number) => void;
  isArriveManual?: boolean;
}

export const SelectLadleCarModal = ({
  open,
  onHide,
  currentLadleCar,
  onSave,
  isArriveManual = false,
}: Props) => {
  const [selectedCar, setSelectedCar] = useState<number | null>(null);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    if (open) {
      setSelectedCar(currentLadleCar);
    }
  }, [open, currentLadleCar]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedCar !== null && selectedCar !== currentLadleCar) {
      setShowConfirm(true);
    } else if (selectedCar !== null) {
      onSave(selectedCar);
      onHide();
    }
  };

  const handleConfirmClose = (value?: string) => {
    setShowConfirm(false);
    if (value === "OK" && selectedCar !== null) {
      onSave(selectedCar);
      onHide();
    }
  };

  return (
    <>
      <MesfModal
        title="SELECT LADLE CAR"
        open={open}
        handleClose={onHide}
        id="select-ladle-car-modal"
        maxWidth="sm"
      >
        <form onSubmit={handleSubmit}>
          <MesfModal.Content dividers sx={modalStyles.modalContent}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <ToggleButton
                  value={1}
                  selected={selectedCar === 1}
                  onChange={() => setSelectedCar(1)}
                  fullWidth
                  sx={{
                    height: 44,
                    fontWeight: 600,
                    backgroundColor:
                      selectedCar === 1
                        ? `${LADLE_CAR_COLORS.lc1.border} !important`
                        : LADLE_CAR_COLORS.lc1.bg,
                    color: "#000",
                    border: `1px solid ${LADLE_CAR_COLORS.lc1.border}`,
                    borderRadius: "4px !important",
                    "&:hover": { backgroundColor: LADLE_CAR_COLORS.lc1.hover },
                  }}
                >
                  LC 1
                </ToggleButton>
              </Grid>
              <Grid item xs={6}>
                <ToggleButton
                  value={2}
                  selected={selectedCar === 2}
                  onChange={() => setSelectedCar(2)}
                  fullWidth
                  sx={{
                    height: 44,
                    fontWeight: 600,
                    backgroundColor:
                      selectedCar === 2
                        ? `${LADLE_CAR_COLORS.lc2.border} !important`
                        : LADLE_CAR_COLORS.lc2.bg,
                    color: "#000",
                    border: `1px solid ${LADLE_CAR_COLORS.lc2.border}`,
                    borderRadius: "4px !important",
                    "&:hover": { backgroundColor: LADLE_CAR_COLORS.lc2.hover },
                  }}
                >
                  LC 2
                </ToggleButton>
              </Grid>
            </Grid>
          </MesfModal.Content>
          <MesfModal.Actions sx={modalStyles.modalActions}>
            <FooterModalButtons
              isSubmitLoading={false}
              onHide={() => onHide()}
              disabled={
                selectedCar === null ||
                (isArriveManual && selectedCar === currentLadleCar)
              }
            />
          </MesfModal.Actions>
        </form>
      </MesfModal>
      <ConfirmationDialogRaw
        title="Confirmation"
        message="Are you sure you want to change the Ladle Car? This will affect the Plug Metrics data for this process."
        open={showConfirm}
        onClose={handleConfirmClose}
      />
    </>
  );
};
